<main class="content-container me-2">
  @if (title) {
    <div [class]="options.titleClass" [attr.aria-label]="title">
      <span style="text-transform: capitalize">{{ title }}</span> Event
      <strong>{{ getFormatFromNow(calendarEvent.eventDate) }}</strong>
    </div>
  }
  @if (message && options.enableHtml) {
    <div
      role="alertdialog"
      aria-live="polite"
      [class]="options.messageClass"
      [innerHTML]="message"></div>
  }
  @if (
    showEntityLink &&
    calendarEvent &&
    calendarEvent.entityName &&
    calendarEvent.entityId &&
    calendarEvent.entityType
  ) {
    <div
      class="entity"
      title="Click for the link overview"
      (click)="openEntityLink(calendarEvent, $event)"
      role="alertdialog"
      aria-live="polite">
      {{ calendarEvent.entityName }}
    </div>
  }
  @if (message && !options.enableHtml) {
    <div
      role="alertdialog"
      aria-live="polite"
      [class]="options.messageClass"
      [attr.aria-label]="message">
      {{ message }}
    </div>
  }
  @if (options.progressBar) {
    <div>
      <div class="toast-progress" [style.width]="width + '%'"></div>
    </div>
  }
</main>
<aside class="toastr-buttons">
  @if (options.closeButton) {
    <button
      (click)="closeToast(calendarEvent.id)"
      class="toast-close-button"
      title="Close and set read"
      aria-label="Close and set read">
      <span aria-hidden="true" class="mx-auto">&times;</span>
    </button>
  }

  <oiq-ui-dropdown #menuRef="OiqUiDropdown">
    <button
      class="oiq-button oiq-button--primary--link oiq-button--sm font-size-1 mx-1 ms-2"
      title="Set postpone interval"
      aria-label="Set postopne interval"
      (click)="menuRef.toggle()">
      Postpone
    </button>
    <ng-template #dropdownTemplate>
      <div class="oiq-ui-list">
        <button
          class="oiq-button oiq-button--link"
          (click)="postponeReminder(calendarEvent, 15, 'minutes')">
          15 minutes
        </button>
        <button
          class="oiq-button oiq-button--link"
          (click)="postponeReminder(calendarEvent, 30, 'minutes')">
          30 minutes
        </button>
        <button
          class="oiq-button oiq-button--link"
          (click)="postponeReminder(calendarEvent, 45, 'minutes')">
          45 minutes
        </button>
        <button
          class="oiq-button oiq-button--link"
          (click)="postponeReminder(calendarEvent, 60, 'minutes')">
          1 hour
        </button>
        <button
          class="oiq-button oiq-button--link"
          (click)="postponeReminder(calendarEvent, 360, 'minutes')">
          6 hour
        </button>
        <button
          class="oiq-button oiq-button--link"
          (click)="postponeReminder(calendarEvent, 720, 'minutes')">
          12 hours
        </button>
        <button
          class="oiq-button oiq-button--link"
          (click)="postponeReminder(calendarEvent, 1400, 'minutes')">
          24 hours
        </button>
      </div>
    </ng-template>
  </oiq-ui-dropdown>
</aside>
